export const DY_API_CAMPAIGN_SELECTOR_NAMES = {
  homeProductRecommendations: 'homepage-product-recommendations',
  pdpProductRecommendations: 'pdp-product-recommendations',
  cartProductRecommendations: 'cart-product-recommendations',
  miniCartProductRecommendations: 'mini-cart-product-recommendations',
}
